export default "__VITE_ASSET__4sNl7RSh__"